<script>
  import { checkbox } from 'vue-strap';
  import estados from '~js/estados';
  import solicitacaoImportacaoServico from '../../servico';
  import pessoaServico from '~modulos/acessos/servico';

  export default {
    components: { checkbox },
    props: {
      solicitacao: Object,
      edicao: Boolean,
      carregando: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        estados: estados,
        moedas: [],
        formapagamentos: [],
        incoterm: [],
        previsaoentregas: [],
        tiposEmbarque: [],
        destinosCarga: [],
        bancos: [],
        agencias: [],
        contas: [],
        configuracao: this.$storage.configuracao(),
        obrigatorioEndereco: false,
        desabilitarEndereco: false,
      }
    },
    computed: {
      observacaoSolicitacaoContador: function() {
        let quantidadeCaracteres = this.solicitacao.observacaoSolicitacao ? 
          this.solicitacao.observacaoSolicitacao.length : 0;

        return 500 - quantidadeCaracteres;
      },
      validarInformacoesFornecedores: function() {
        return this.configuracao.obrigatorioIndicarFornecedoresImportacao ? 'required' : '';
      },
    },
    methods: {
      listaDeBancos() {
        return solicitacaoImportacaoServico
          .listaBancos()
          .then(bancos => {
            this.bancos = bancos;
          });
      },
      listaDeMoedas() {
        return solicitacaoImportacaoServico
          .listaMoedas()
          .then(moedas => {
            this.moedas = moedas;
          });
      },
      listaDeFormaPagamentos() {
        return solicitacaoImportacaoServico
          .listaFormaPagamentos()
          .then(formapagamentos => {
            this.formapagamentos = formapagamentos;
          });
      },
      listaDeIncoterm() {
        return solicitacaoImportacaoServico
          .listaIncoterm()
          .then(incoterm => {
            this.incoterm = incoterm;
          });
      },
      listaDePrevisaoEntregas() {
        return solicitacaoImportacaoServico
          .listaPrevisaoEntregas()
          .then(previsaoentregas => {
            this.previsaoentregas = previsaoentregas;
          });
      },
      listaDeTipoEmbarque() {
        return solicitacaoImportacaoServico
          .listaTipoEmbarque()
          .then(tiposembarque => {
            this.tiposEmbarque = tiposembarque;
          });
      },
      listaDeDestinoCarga() {
        return solicitacaoImportacaoServico
          .listaDestinoCarga()
          .then(destinoscarga => {
            this.destinosCarga = destinoscarga;
          });
      },
      preencherDadosContato() {
        let usuario = this.$storage.usuario();

        this.$set(this.solicitacao, 'nomeSolicitante', usuario.nome);
        this.$set(this.solicitacao, 'emailSolicitante', usuario.email);
        this.$set(this.solicitacao, 'telefoneSolicitante', usuario.telefone.substring(0, 20));
      },
      validarDadosSolicitacao() {
        return this.$validator.validateAll();
      },
      listaDeAgencias() {
        if ((this.solicitacao.idImportacaoBancoDebito == 0) | (this.solicitacao.idImportacaoBancoDebito == null))
          return [];

        return solicitacaoImportacaoServico
          .listaAgencias(this.solicitacao.idImportacaoBancoDebito)
          .then(agencias => {
            this.agencias = agencias;
          });
      },
      listaDeContas() {
        if ((this.solicitacao.idImportacaoAgenciaDebito == 0) | (this.solicitacao.idImportacaoAgenciaDebito == null))
          return [];

        return solicitacaoImportacaoServico
          .listaContas(this.solicitacao.idImportacaoAgenciaDebito)
          .then(contas => {
            this.contas = contas;
          });
      },
      getCEP() {
        if (this.carregando) return;

        let textoCEP = this.solicitacao.cepLocalAlocado.replace('-', '').replace('.', '')

        if (textoCEP.length == 8) {
          this.desabilitarEndereco = true;

          pessoaServico
            .cep(textoCEP)
            .then(cepObj => {
              this.solicitacao.enderecoLocalAlocado = cepObj.logradouro.substring(0, 100);
              this.solicitacao.bairroLocalAlocado = cepObj.bairro.substring(0, 40);
              this.solicitacao.cidadeLocalAlocado = cepObj.localidade.substring(0, 40);
              this.solicitacao.estadoLocalAlocado = cepObj.uf;
              this.solicitacao.numeroLocalAlocado = "";
              this.solicitacao.complementoLocalAlocado = "";
              this.desabilitarEndereco = false;
            })
            .catch(error => {
              this.desabilitarEndereco = false;
            });
        }
      }
    },
    mounted() {
      this.$events.on('carregarMoedas', this.listaDeMoedas);
      this.$events.on('carregarFormaPagamentos', this.listaDeFormaPagamentos);
      this.$events.on('carregarIncoterm', this.listaDeIncoterm);
      this.$events.on('carregarPrevisaoEntregas', this.listaDePrevisaoEntregas);
      this.$events.on('carregarTipoEmbarque', this.listaDeTipoEmbarque);
      this.$events.on('carregarDestinoCarga', this.listaDeDestinoCarga);
      this.$events.on('carregarBancos', this.listaDeBancos);
    },
    updated(){
        const _this = this;

        this.$watch('solicitacao.cepLocalAlocado', function () {
        _this.getCEP();
        })
    },
    watch: {
      'solicitacao.idImportacaoBancoDebito': 'listaDeAgencias',
      'solicitacao.idImportacaoAgenciaDebito': 'listaDeContas',
    }
  }
</script>

<template>
  <div>
    <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
      <div class="btn-group" role="group">
        <button type="button" :class="['btn btn-primary', {'active': true}]">
          Financiador
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <div class="form-group" :class="{'has-error': errors.has('dataAprovacao')}">
          <label class="control-label" for="dataAprovacao">Data aprovação</label>

          <input type="text"
                 class="form-control"
                 id="dataAprovacao"
                 v-mascara="'data'"
                 placeholder="    /    /"
                 v-validate="'date_format:DD/MM/YYYY'"
                 data-vv-name="dataAprovacao"
                 data-vv-as="data aprovação"
                 v-model="solicitacao.dataAprovacao">

          <p class="text-danger" v-show="errors.has('dataAprovacao')">{{ errors.first('dataAprovacao') }}</p>
        </div>
      </div>

      <div class="col-sm-9">
        <div class="form-group" :class="{'has-error': errors.has('numeroProcesso')}">
          <label class="control-label" for="numeroProcesso">Número processo</label>

          <input type="text"
                 class="form-control"
                 id="numeroProcesso"
                 v-model="solicitacao.numeroProcesso"
                 data-vv-as="numeroProcesso"
                 data-vv-name="número processo"
                 maxlength="50">

          <p class="text-danger" v-show="errors.has('numeroProcesso')">{{ errors.first('numeroProcesso') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="descricaoImportacaoFinanciador">
            Descrição da Importação aprovada  junto ao Financiador
          </label>

          <textarea class="form-control"
                    id="descricaoImportacaoFinanciador"
                    v-model="solicitacao.descricaoImportacaoFinanciador">
          </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('tituloprojeto')}">
          <label class="control-label" for="tituloprojeto">Título do projeto</label>

          <input type="text"
                 class="form-control"
                 id="tituloprojeto"
                 v-model="solicitacao.tituloProjeto"
                 data-vv-as="tituloprojeto"
                 data-vv-name="título do projeto"
                 maxlength="250">

          <p class="text-danger" v-show="errors.has('tituloprojeto')">{{ errors.first('tituloprojeto') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('objetivoprojeto')}">
          <label class="control-label" for="objetivoprojeto">Objetivo do projeto</label>

          <input type="text"
                 class="form-control"
                 id="objetivoprojeto"
                 v-model="solicitacao.objetivoProjeto"
                 data-vv-as="objetivoprojeto"
                 data-vv-name="objetivo do projeto"
                 maxlength="350">

          <p class="text-danger" v-show="errors.has('objetivoprojeto')">{{ errors.first('objetivoprojeto') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('area')}">
          <label class="control-label" for="area">Área</label>

          <input type="text"
                 class="form-control"
                 id="area"
                 v-model="solicitacao.area"
                 data-vv-as="area"
                 data-vv-name="área"
                 maxlength="150">

          <p class="text-danger" v-show="errors.has('area')">{{ errors.first('area') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('subarea')}">
          <label class="control-label" for="subarea">Sub área</label>

          <input type="text"
                 class="form-control"
                 id="subarea"
                 v-model="solicitacao.subArea"
                 data-vv-as="subarea"
                 data-vv-name="sub área"
                 maxlength="150">

          <p class="text-danger" v-show="errors.has('subarea')">{{ errors.first('subarea') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group" :class="{'has-error': errors.has('instituicaosede')}">
          <label class="control-label" for="instituicaosede">Instituição sede</label>

          <input type="text"
                 class="form-control"
                 id="instituicaosede"
                 v-model="solicitacao.instituicaoSede"
                 data-vv-as="instituicaosede"
                 data-vv-name="instiuição sede"
                 maxlength="150">

          <p class="text-danger" v-show="errors.has('area')">{{ errors.first('area') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group" :class="{'has-error': errors.has('cnpjexecutora')}">
          <label class="control-label" for="cnpjexecutora">CNPJ Executora</label>

          <input type="text"
                 class="form-control"
                 id="cnpjexecutora"
                 v-mascara="'cnpj'"
                 v-model="solicitacao.cnpjExecutora"
                 data-vv-as="cnpj executora"
                 data-vv-name="cnpjexecutora"
                 v-validate="'cnpj'">

          <p class="text-danger" v-show="errors.has('cnpjexecutora')">{{ errors.first('cnpjexecutora') }}</p>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="form-group" :class="{'has-error': errors.has('credenciamentocnpq')}">
          <label class="control-label" for="credenciamentocnpq">Credenciamento CNPQ</label>

          <input type="text"
                 class="form-control"
                 id="credenciamentocnpq"
                 v-model="solicitacao.credenciamentoCNPQ"
                 data-vv-as="credenciamentocnpq"
                 data-vv-name="credenciamento CNPQ"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('credenciamentocnpq')">{{ errors.first('credenciamentocnpq') }}</p>
        </div>
      </div>
    </div>

    <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
      <div class="btn-group" role="group">
        <button type="button" :class="['btn btn-primary', {'active': true}]">
          Dados Local de Entrega e de doação de Bens e Equipamentos
        </button>
      </div>
    </div>

    <div class="row">

      <div class="col-sm-3">
        <div class="form-group" :class="{'has-error': errors.has('ceplocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolImportacao}">
          <label class="control-label" for="cep-local-alocado">CEP</label>

          <input type="text"
                 class="form-control"
                 id="cep-local-alocado"
                 data-vv-name="ceplocalAlocado"
                 data-vv-as="cep"
                 :disabled="desabilitarEndereco"
                 v-validate="`${configuracao.obrigatorioLocalAlocadoSolImportacao ? 'required' : ''}`"
                 v-model="solicitacao.cepLocalAlocado"
                 v-mascara="'cep'">

          <p class="text-danger" v-show="errors.has('ceplocalAlocado')">{{ errors.first('ceplocalAlocado') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('enderecolocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolImportacao}">
          <label class="control-label" for="endereco-local-alocado">Endereço</label>

          <input type="text"
                 class="form-control"
                 id="endereco-local-alocado"
                 v-model="solicitacao.enderecoLocalAlocado"
                 data-vv-name="enderecolocalAlocado"
                 :disabled="desabilitarEndereco"
                 data-vv-as="endereço"
                 v-validate="`${configuracao.obrigatorioLocalAlocadoSolImportacao ? 'required' : ''}`"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('enderecolocalAlocado')">{{ errors.first('enderecolocalAlocado') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group" :class="{'has-error': errors.has('numerolocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolImportacao}">
          <label class="control-label" for="numero-local-alocado">Número</label>

          <input type="text"
                 class="form-control"
                 id="numero-local-alocado"
                 v-model="solicitacao.numeroLocalAlocado"
                 data-vv-name="numerolocalAlocado"
                 data-vv-as="número"
                 v-validate="`${configuracao.obrigatorioLocalAlocadoSolImportacao ? 'required' : ''}`"
                 maxlength="10">

          <p class="text-danger" v-show="errors.has('numerolocalAlocado')">{{ errors.first('numerolocalAlocado') }}</p>
        </div>
      </div>
    </div>

    <div class="row">

      <div class="col-sm-2">
        <div class="form-group">
          <label class="control-label" for="complemento-local-alocado">Complemento</label>

          <input type="text"
                 class="form-control"
                 id="complemento-local-alocado"
                 v-model="solicitacao.complementoLocalAlocado"
                 data-vv-name="complementolocalAlocado"
                 data-vv-as="complemento"
                 maxlength="80">

        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group" :class="{'has-error': errors.has('bairrolocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolImportacao}">
          <label class="control-label" for="bairro-local-alocado">Bairro</label>

          <input type="text"
                 class="form-control"
                 id="bairro-local-alocado"
                 v-model="solicitacao.bairroLocalAlocado"
                 data-vv-name="bairrolocalAlocado"
                 :disabled="desabilitarEndereco"
                 data-vv-as="bairro"
                 v-validate="`${configuracao.obrigatorioLocalAlocadoSolImportacao ? 'required' : ''}`"
                 maxlength="40">

          <p class="text-danger" v-show="errors.has('bairrolocalAlocado')">{{ errors.first('bairrolocalAlocado') }}</p>
        </div>
      </div>

      <div class="col-sm-4">

        <div class="form-group" :class="{'has-error': errors.has('cidadelocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolImportacao}">
          <label class="control-label" for="cidade-local-alocado">Cidade</label>

          <input type="text"
                 class="form-control"
                 id="cidade-local-alocado"
                 v-model="solicitacao.cidadeLocalAlocado"
                 data-vv-name="cidadelocalAlocado"
                 :disabled="desabilitarEndereco"
                 data-vv-as="cidade"
                 v-validate="`${configuracao.obrigatorioLocalAlocadoSolImportacao ? 'required' : ''}`"
                 maxlength="40">

          <p class="text-danger" v-show="errors.has('cidadelocalAlocado')">{{ errors.first('cidadelocalAlocado') }}</p>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group" :class="{'has-error': errors.has('estadolocalAlocado'), 'required': configuracao.obrigatorioLocalAlocadoSolImportacao}">
          <label class="control-label" for="estado-local-alocado">Estado</label>

          <select class="form-control"
                  id="estado-local-alocado"
                  data-vv-name="estadolocalAlocado"
                  :disabled="desabilitarEndereco"
                  data-vv-as="estado"
                  v-validate="`${configuracao.obrigatorioLocalAlocadoSolImportacao ? 'required' : ''}`"
                  v-model="solicitacao.estadoLocalAlocado">
            <option value="" selected>Selecione...</option>
            <option :value="estado.sigla" v-for="estado in estados">{{ estado.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('estadolocalAlocado')">{{ errors.first('estadolocalAlocado') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-8">
        <div class="form-group" :class="{'has-error': errors.has('unidadelocalAlocado'), 'required': configuracao.obrigatorioUnidadeInstituicao}">
          <label class="control-label" for="unidade-local-alocado">Unidade</label>

          <input type="text"
                 class="form-control"
                 id="unidade-local-alocado"
                 data-vv-name="unidadelocalAlocado"
                 data-vv-as="unidade"
                 v-validate="`${configuracao.obrigatorioUnidadeInstituicao ? 'required' : ''}`"
                 v-model="solicitacao.unidadeLocalAlocado"
                 maxlength="40">

          <p class="text-danger" v-show="errors.has('unidadelocalAlocado')">{{ errors.first('unidadelocalAlocado') }}</p>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="form-group" :class="{'has-error': errors.has('cnpjUnidadeLocalAlocado'), 'required': configuracao.obrigatorioCNPJUnidadeInstituicao}">
          <label class="control-label" for="cnpj-unidade-local-alocado">CNPJ Unidade</label>

          <input type="text"
                 class="form-control"
                 id="cnpj-unidade-local-alocado"
                 v-mascara="'cnpj'"
                 v-model="solicitacao.cnpjUnidadeLocalAlocado"
                 data-vv-as="cnpj unidade"
                 data-vv-name="cnpjUnidadeLocalAlocado"
                 v-validate="`${configuracao.obrigatorioCNPJUnidadeInstituicao ? 'required|cnpj' : 'cnpj'}`">

          <p class="text-danger" v-show="errors.has('cnpjUnidadeLocalAlocado')">{{ errors.first('cnpjUnidadeLocalAlocado') }}</p>
        </div>
      </div>
    </div>

    <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
      <div class="btn-group" role="group">
        <button type="button" :class="['btn btn-primary', {'active': true}]">
          Representante no Brasil
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label" for="nomeempresainvoice">Nome empresa</label>

          <input type="text"
                 class="form-control"
                 id="nomeempresainvoice"
                 data-vv-name="nomeempresainvoice"
                 data-vv-as="nome empresa invoice"
                 v-model="solicitacao.nomeEmpresaInvoice"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('nomeempresainvoice')">{{ errors.first('nomeempresainvoice') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="contatoempresainvoice">Contato empresa</label>

          <input type="text"
                 class="form-control"
                 id="contatoempresainvoice"
                 data-vv-name="contatoempresainvoice"
                 data-vv-as="contato empresa invoice"
                 v-model="solicitacao.contatoEmpresaInvoice"
                 maxlength="200">

          <p class="text-danger" v-show="errors.has('contatoempresainvoice')">{{ errors.first('contatoempresainvoice') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="emailEmpresaInvoice">Email</label>

          <input type="text"
                 class="form-control"
                 id="emailinvoice"
                 data-vv-name="emailinvoice"
                 data-vv-as="email invoice"
                 v-model="solicitacao.emailEmpresaInvoice"
                 maxlength="300">

          <p class="text-danger" v-show="errors.has('emailinvoice')">{{ errors.first('emailinvoice') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label" for="siteempresainvoice">Site</label>

          <input type="text"
                 class="form-control"
                 id="siteempresainvoice"
                 data-vv-name="siteempresainvoice"
                 data-vv-as="site empresa invoice"
                 v-model="solicitacao.siteEmpresaInvoice"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('siteempresainvoice')">{{ errors.first('siteempresainvoice') }}</p>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label class="control-label" for="telefone1empresainvoice">Telefone 1</label>

          <input type="text"
                 class="form-control"
                 id="telefone1empresainvoice"
                 data-vv-name="telefone1empresainvoice"
                 v-model="solicitacao.telefone1EmpresaInvoice"
                 data-vv-as="telefone 1"
                 maxlength="15">

          <p class="text-danger" v-show="errors.has('telefone1empresainvoice')">{{ errors.first('telefone1empresainvoice') }}</p>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label class="control-label" for="telefone2empresainvoice">Telefone 2</label>

          <input type="text"
                 class="form-control"
                 id="telefone2empresainvoice"
                 data-vv-name="telefone2empresainvoice"
                 v-model="solicitacao.telefone2EmpresaInvoice"
                 data-vv-as="telefone 2"
                 maxlength="15">

          <p class="text-danger" v-show="errors.has('telefone2empresainvoice')">{{ errors.first('telefone2empresainvoice') }}</p>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label" for="paisempresainvoice">País</label>

          <input type="text"
                 class="form-control"
                 id="paisempresainvoice"
                 data-vv-name="paisempresainvoice"
                 data-vv-as="país empresa invoice"
                 v-model="solicitacao.paisEmpresaInvoice"
                 maxlength="30">

          <p class="text-danger" v-show="errors.has('paisempresainvoice')">{{ errors.first('paisempresainvoice') }}</p>
        </div>
      </div>
    </div>

    <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
      <div class="btn-group" role="group">
        <button type="button" :class="['btn btn-primary', {'active': true}]">
          Dados do Exportador
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-9">
        <div class="form-group">
          <label class="control-label" for="nomeexportador">Nome exportador</label>

          <input type="text"
                 class="form-control"
                 id="nomeexportador"
                 data-vv-name="nomeexportador"
                 data-vv-as="nome exportaador"
                 v-model="solicitacao.nomeExportador"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('nomeexportador')">{{ errors.first('nomeexportador') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="emailexportador">Email</label>

          <input type="text"
                 class="form-control"
                 id="emailexportador"
                 data-vv-name="emailexportador"
                 data-vv-as="email exportador"
                 v-model="solicitacao.emailExportador"
                 maxlength="300">

          <p class="text-danger" v-show="errors.has('emailexportador')">{{ errors.first('emailexportador') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label" for="siteexportador">Site</label>

          <input type="text"
                 class="form-control"
                 id="siteexportador"
                 data-vv-name="siteexportador"
                 data-vv-as="site exportador"
                 v-model="solicitacao.siteExportador"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('siteempresainvoice')">{{ errors.first('siteempresainvoice') }}</p>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label class="control-label" for="telefone1exportador">Telefone 1</label>

          <input type="text"
                 class="form-control"
                 id="telefone1exportador"
                 data-vv-name="telefone1exportador"
                 v-model="solicitacao.telefone1Exportador"
                 data-vv-as="telefone 1"
                 maxlength="15">

          <p class="text-danger" v-show="errors.has('telefone1exportador')">{{ errors.first('telefone1exportador') }}</p>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label class="control-label" for="telefone2exportador">Telefone 2</label>

          <input type="text"
                 class="form-control"
                 id="telefone2exportador"
                 data-vv-name="telefone2exportador"
                 v-model="solicitacao.telefone2Exportador"
                 data-vv-as="telefone 2"
                 maxlength="15">

          <p class="text-danger" v-show="errors.has('telefone2exportador')">{{ errors.first('telefone2exportador') }}</p>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label" for="paisexportador">País</label>

          <input type="text"
                 class="form-control"
                 id="paisexportador"
                 data-vv-name="paisexportador"
                 data-vv-as="país exportador"
                 v-model="solicitacao.paisExportador"
                 maxlength="30">

          <p class="text-danger" v-show="errors.has('paisexportador')">{{ errors.first('paisexportador') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label" for="enderecoexportador">Endereço</label>

          <input type="text"
                 class="form-control"
                 id="enderecoexportador"
                 data-vv-name="enderecoexportador"
                 data-vv-as="endereço exportador"
                 v-model="solicitacao.enderecoExportador"
                 maxlength="300">

          <p class="text-danger" v-show="errors.has('enderecoexportador')">{{ errors.first('enderecoexportador') }}</p>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label class="control-label" for="zipcodeexportador">ZIP Code</label>

          <input type="text"
                 class="form-control"
                 id="zipcodeexportador"
                 data-vv-name="zipcodeexportador"
                 data-vv-as="ZIP code exportador"
                 v-model="solicitacao.zipCodeExportador"
                 maxlength="30">

          <p class="text-danger" v-show="errors.has('zipcodeexportador')">{{ errors.first('zipcodeexportador') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="cidadeexportador">Cidade</label>

          <input type="text"
                 class="form-control"
                 id="cidadeexportador"
                 data-vv-name="cidadeexportador"
                 data-vv-as="cidade exportador"
                 v-model="solicitacao.cidadeExportador"
                 maxlength="40">

          <p class="text-danger" v-show="errors.has('cidadeexportador')">{{ errors.first('cidadeexportador') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="estadoexportador">Estado</label>

          <input type="text"
                 class="form-control"
                 id="estadoexportador"
                 data-vv-name="estadoexportador"
                 data-vv-as="estado exportador"
                 v-model="solicitacao.estadoExportador"
                 maxlength="30">

          <p class="text-danger" v-show="errors.has('estadoexportador')">{{ errors.first('estadoexportador') }}</p>
        </div>
      </div>
    </div>

    <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
      <div class="btn-group" role="group">
        <button type="button" :class="['btn btn-primary', {'active': true}]">
          Dados Bancários Exportador
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label" for="instituicaoFinanceira">Instituição Financeira</label>

          <input type="text"
                 class="form-control"
                 id="instituicaoFinanceira"
                 data-vv-name="instituicaoFinanceira"
                 data-vv-as="instituição financeira"
                 v-model="solicitacao.instituicaoFinanceira"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('instituicaoFinanceira')">{{ errors.first('instituicaoFinanceira') }}</p>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="form-group">
          <label class="control-label" for="enderecoAgencia">Endereço da Agência</label>

          <input type="text"
                 class="form-control"
                 id="enderecoAgencia"
                 data-vv-name="enderecoAgencia"
                 data-vv-as="endereço agência"
                 v-model="solicitacao.enderecoAgencia"
                 maxlength="200">

          <p class="text-danger" v-show="errors.has('enderecoAgencia')">{{ errors.first('enderecoAgencia') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="numeroAgencia">Número Agência</label>

          <input type="text"
                 class="form-control"
                 id="numeroAgencia"
                 data-vv-name="numeroAgencia"
                 data-vv-as="número agênciar"
                 v-model="solicitacao.numeroAgencia"
                 maxlength="20">

          <p class="text-danger" v-show="errors.has('numeroAgencia')">{{ errors.first('numeroAgencia') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="numeroConta">Número da Conta</label>

          <input type="text"
                 class="form-control"
                 id="numeroConta"
                 data-vv-name="numeroConta"
                 data-vv-as="número da conta"
                 v-model="solicitacao.numeroConta"
                 maxlength="30">

          <p class="text-danger" v-show="errors.has('numeroConta')">{{ errors.first('numeroConta') }}</p>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label" for="iban">IBAN</label>

          <input type="text"
                 class="form-control"
                 id="iban"
                 data-vv-name="iban"
                 data-vv-as="IBAN"
                 v-model="solicitacao.iban"
                 maxlength="50">

          <p class="text-danger" v-show="errors.has('iban')">{{ errors.first('iban') }}</p>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="form-group">
          <label class="control-label" for="SWFITCode">
            SWFIT Code
          </label>

          <input type="text"
                 class="form-control"
                 id="SWFITCode"
                 data-vv-name="SWFITCode"
                 data-vv-as="SWFIT Code"
                 v-model="solicitacao.swfitCode"
                 maxlength="50">

          <p class="text-danger" v-show="errors.has('SWFITCode')">{{ errors.first('SWFITCode') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="informacoesComplementares">
            Informações Complementares
          </label>

          <textarea class="form-control"
                    id="informacoesComplementares"
                    v-model="solicitacao.informacoesComplementares">
          </textarea>
        </div>
      </div>
    </div>

    <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
      <div class="btn-group" role="group">
        <button type="button" :class="['btn btn-primary', {'active': true}]">
          Números de Controle
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <div class="form-group" :class="{'has-error': errors.has('dataProforma')}">
          <label class="control-label" for="dataProforma">Data da Proforma</label>

          <input type="text"
                 class="form-control"
                 id="dataProforma"
                 v-mascara="'data'"
                 placeholder="    /    /"
                 v-validate="'date_format:DD/MM/YYYY'"
                 data-vv-name="dataProforma"
                 data-vv-as="data  proforma"
                 v-model="solicitacao.dataProforma">

          <p class="text-danger" v-show="errors.has('dataProforma')">{{ errors.first('dataProforma') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('numeroProformaInvoice')}">
          <label class="control-label" for="numeroProformaInvoice">N° Proforma Invoice</label>

          <input type="text"
                 class="form-control"
                 id="numeroProformaInvoice"
                 data-vv-name="numeroProformaInvoice"
                 v-model="solicitacao.numeroProformaInvoice"
                 data-vv-as="número proforma invoice"
                 maxlength="20">

          <p class="text-danger" v-show="errors.has('numeroProformaInvoice')">{{ errors.first('numeroProformaInvoice') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group" :class="{'has-error': errors.has('validadeProposta')}">
          <label class="control-label" for="validadeProposta">Validade Proposta</label>

          <input type="text"
                 class="form-control"
                 id="validadeProposta"
                 data-vv-name="validadeProposta"
                 v-model="solicitacao.validadeProposta"
                 data-vv-as="validade proposta"
                 maxlength="15">

          <p class="text-danger" v-show="errors.has('validadeProposta')">{{ errors.first('validadeProposta') }}</p>
        </div>
      </div>


    </div>

    <div class="row">
      <div class="col-md-3">
        <div class="form-group" :class="{'has-error': errors.has('dataNR')}">
          <label class="control-label" for="dataNR">Data NR</label>

          <input type="text"
                 class="form-control"
                 id="dataNR"
                 v-mascara="'data'"
                 placeholder="    /    /"
                 v-validate="'date_format:DD/MM/YYYY'"
                 data-vv-name="dataNR"
                 data-vv-as="data  NR"
                 v-model="solicitacao.dataNR">

          <p class="text-danger" v-show="errors.has('dataNR')">{{ errors.first('dataNR') }}</p>
        </div>
      </div>

      <div class="col-sm-9">
        <div class="form-group" :class="{'has-error': errors.has('nossaReferencia')}">
          <label class="control-label" for="nossaReferencia">Nossa Referência</label>

          <input type="text"
                 class="form-control"
                 id="nossaReferencia"
                 data-vv-name="nossaReferencia"
                 v-model="solicitacao.nossaReferencia"
                 data-vv-as="nossa referência"
                 maxlength="20">

          <p class="text-danger" v-show="errors.has('nossaReferencia')">{{ errors.first('nossaReferencia') }}</p>
        </div>
      </div>
    </div>

    <div class="btn-group btn-group-justified margin-bottom-15 hidden-print" role="group">
      <div class="btn-group" role="group">
        <button type="button" :class="['btn btn-primary', {'active': true}]">
          Condições Gerais das compras (INCOTERMS)
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('formapagamento')}">
          <label class="control-label" for="formapagamento">Forma Pagamento</label>

          <select class="form-control"
                  id="formapagamento"
                  data-vv-name="formapagamento"
                  data-vv-as="forma de pagamento"
                  v-model="solicitacao.idImportacaoFormaPagamento">
            <option value="" selected>Selecione...</option>
            <option :value="formapagamento.idImportacaoFormaPagamento" v-for="formapagamento in formapagamentos">{{ formapagamento.formaPagamento }}</option>
          </select>
          <p class="text-danger" v-show="errors.has('formapagamento')">{{ errors.first('formapagamento') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('previsaoEntrega')}">
          <label class="control-label" for="previsaoEntrega">Previsão de Entrega</label>

          <select class="form-control"
                  id="previsaoEntrega"
                  data-vv-name="previsaoEntrega"
                  data-vv-as="previsão de entrega"
                  v-model="solicitacao.idImportacaoPrevisaoEntrega">
            <option value="" selected>Selecione...</option>
            <option :value="previsaoentrega.idImportacaoPrevisaoEntrega" v-for="previsaoentrega in previsaoentregas">{{ previsaoentrega.previsaoEntrega }}</option>
          </select>
          <p class="text-danger" v-show="errors.has('previsaoEntrega')">{{ errors.first('previsaoEntrega') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('incoterm')}">
          <label class="control-label" for="incoterm">Incoterm</label>

          <select class="form-control"
                  id="incoterm"
                  data-vv-name="incoterm"
                  data-vv-as="incoterm"
                  v-model="solicitacao.idImportacaoIncoterm">
            <option value="" selected>Selecione...</option>
            <option :value="incoterm.idImportacaoIncoterm" v-for="incoterm in incoterm">{{ incoterm.incoterm }}</option>
          </select>
          <p class="text-danger" v-show="errors.has('incoterm')">{{ errors.first('incoterm') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('moeda')}">
          <label class="control-label" for="moeda">Moeda</label>

          <select class="form-control"
                  id="moeda"
                  data-vv-name="moeda"
                  data-vv-as="moeda"
                  v-model="solicitacao.idMoeda">
            <option value="" selected>Selecione...</option>
            <option :value="moeda.idImportacaoMoeda" v-for="moeda in moedas">{{ moeda.nomeMoeda }}</option>
          </select>
          <p class="text-danger" v-show="errors.has('moeda')">{{ errors.first('moeda') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('tipoembarque')}">
          <label class="control-label" for="tipoembarque">Tipo Embarque</label>

          <select class="form-control"
                  id="tipoembarque"
                  data-vv-name="tipoembarque"
                  data-vv-as="tipo embarque"
                  v-model="solicitacao.idImportacaoTipoEmbarque">
            <option value="" selected>Selecione...</option>
            <option :value="tipoembarque.idImportacaoTipoEmbarque" v-for="tipoembarque in tiposEmbarque">{{ tipoembarque.tipoEmbarque }}</option>
          </select>
          <p class="text-danger" v-show="errors.has('tipoembarque')">{{ errors.first('tipoembarque') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group" :class="{'has-error': errors.has('destinocarga')}">
          <label class="control-label" for="destinocarga">Destino Carga</label>

          <select class="form-control"
                  id="destinocarga"
                  data-vv-name="destinocarga"
                  data-vv-as="destino carga"
                  v-model="solicitacao.idImportacaoDestinoCarga">
            <option value="" selected>Selecione...</option>
            <option :value="destinocarga.idImportacaoDestinoCarga" v-for="destinocarga in destinosCarga">{{ destinocarga.destinoCarga }}</option>
          </select>
          <p class="text-danger" v-show="errors.has('destinocarga')">{{ errors.first('destinocarga') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group" :class="{'has-error': errors.has('banco')}">
          <label class="control-label" for="banco">Banco de Débito</label>

          <select class="form-control"
                  id="banco"
                  data-vv-name="banco"
                  data-vv-as="banco de débito"
                  v-model="solicitacao.idImportacaoBancoDebito">
            <option value="" selected>Selecione...</option>
            <option :value="banco.idBanco" v-for="banco in bancos">{{ banco.nome }} - {{ banco.numero }}</option>
          </select>
          <p class="text-danger" v-show="errors.has('banco')">{{ errors.first('banco') }}</p>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group" :class="{'has-error': errors.has('agencia')}">
          <label class="control-label" for="agencia">Agência de Débito</label>

          <select class="form-control"
                  id="agencia"
                  data-vv-name="agencia"
                  data-vv-as="agência de débito"
                  v-model="solicitacao.idImportacaoAgenciaDebito">
            <option value="" selected>Selecione...</option>
            <option :value="agencia.idAgencia" v-for="agencia in agencias">{{ agencia.numero }}</option>
          </select>
          <p class="text-danger" v-show="errors.has('agencia')">{{ errors.first('agencia') }}</p>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group" :class="{'has-error': errors.has('conta')}">
          <label class="control-label" for="conta">Conta de Débito</label>

          <select class="form-control"
                  id="conta"
                  data-vv-name="conta"
                  data-vv-as="conta de débito"
                  v-model="solicitacao.idImportacaoContaDebito">
            <option value="" selected>Selecione...</option>
            <option :value="conta.id" v-for="conta in contas">{{ conta.nome }}</option>
          </select>
          <p class="text-danger" v-show="errors.has('conta')">{{ errors.first('conta') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="outrasCondicoesCompra">
            Outras Condições Gerais das Compras (INCOTERMS)
          </label>

          <textarea class="form-control"
                    id="outrasCondicoesCompra"
                    v-model="solicitacao.outrasCondicoesCompra">
          </textarea>
        </div>
      </div>
    </div>

    <div class="hr-line-dashed margin-top-5"></div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label class="control-label" for="observacao-solicitacao">
            Observação da Solicitação/Detalhes ({{ observacaoSolicitacaoContador }})
          </label>

          <textarea class="form-control"
                    id="observacao-solicitacao"
                    v-model="solicitacao.observacaoSolicitacao"
                    maxlength="500">
          </textarea>
        </div>
      </div>
    </div>

    <p>
      <b>
        Informe os dados da pessoa que devemos contatar, caso haja dúvidas ao
        processarmos essa solicitação, ou marque o campo abaixo.
      </b>
    </p>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-xs btn-success" @click="preencherDadosContato">
            <i class="fa fa-user-circle"></i> Clique aqui para preencher com os seus dados
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('nomeSolicitante')}">
          <label class="control-label" for="nome-solicitante">Nome</label>

          <input type="text"
                 class="form-control"
                 id="nome-solicitante"
                 data-vv-name="nomeSolicitante"
                 v-model="solicitacao.nomeSolicitante"
                 v-validate
                 data-vv-rules="required"
                 data-vv-as="nome"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('nomeSolicitante')">{{ errors.first('nomeSolicitante') }}</p>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('emailSolicitante')}">
          <label class="control-label" for="email-solicitante">E-mail</label>

          <input type="text"
                 class="form-control"
                 id="email-solicitante"
                 data-vv-name="emailSolicitante"
                 v-model="solicitacao.emailSolicitante"
                 v-validate
                 data-vv-rules="required"
                 data-vv-as="e-mail"
                 maxlength="300">

          <p class="text-danger" v-show="errors.has('emailSolicitante')">{{ errors.first('emailSolicitante') }}</p>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group required" :class="{'has-error': errors.has('telefoneSolicitante')}">
          <label class="control-label" for="telefone-solicitante">Telefone</label>

          <input type="text"
                 class="form-control"
                 id="telefone-solicitante"
                 data-vv-name="telefoneSolicitante"
                 v-model="solicitacao.telefoneSolicitante"
                 v-validate
                 data-vv-rules="required"
                 data-vv-as="telefone"
                 v-mascara="'telefone'">

          <p class="text-danger" v-show="errors.has('telefoneSolicitante')">{{ errors.first('telefoneSolicitante') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .select2-container--bootstrap .select2-results__option[aria-disabled=true] {
    color: #ED5565!important;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-importacao/componentes/compartilhado/FormDadosSolicitacao.vue